<h1 mat-dialog-title>
	<span [translate]="isCreation ? 'admin.frais.indemnites.fraisMissions.detail.datesApplication.titleCreation' : 'admin.frais.indemnites.fraisMissions.detail.datesApplication.titleModification'"></span>
	<span [mat-dialog-close]><i class="zmdi zmdi-close"></i></span>
</h1>

<div mat-dialog-content>
	<form #form="ngForm">
		<!-- Date d'application -->
		<div class="row">
			<custom-input ngDefaultControl
						  id="dateApplication"
						  name="dateApplication"
						  [ngModel]="dateApplication.dateApplication"
						  [(customModel)]="dateApplication.dateApplication"
						  customType="date"
						  [lCol]="3"
						  [rCol]="4"
						  libelle="admin.frais.indemnites.fraisMissions.detail.datesApplication.date"
						  [required]="true"
						  [disabled]="!isCreation">
			</custom-input>
		</div>

		<!-- Montant total -->
		<div class="row">
			<custom-input ngDefaultControl
						  id="montantTotal"
						  name="montantTotal"
						  [(ngModel)]="montantTotal"
						  customType="montant"
						  [lCol]="3"
						  [rCol]="4"
						  libelle="admin.frais.indemnites.fraisMissions.detail.datesApplication.montantTotal"
						  [nbDecimales]="2"
						  [montantDevise]="deviseSelectionnee"
						  [listeDevise]="data.listeDevises"
						  (onDeviseChange)="onDeviseChange($event)"
						  (onChange)="onMontantTotalChange()"
						  [postTooltipNio]="{content: ('admin.frais.indemnites.fraisMissions.detail.datesApplication.montantTotalTooltip' | translate)}">
			</custom-input>
		</div>

		<!-- Indemnités par domaine -->
		<div class="row" *ngFor="let indemnite of listeIndemnites; let i = index">
			<custom-input ngDefaultControl
						  [id]="'pourcentage_' + i"
						  [name]="'pourcentage_' + i"
						  [(ngModel)]="indemnite.pourcentage"
						  customType="number"
						  [lCol]="3"
						  [rCol]="2"
						  [libelle]="indemnite.libelleDomaine"
						  [nbDecimales]="2"
						  [readonly]="!montantTotal"
						  (onChange)="onPourcentageChange(indemnite)"
						  suffix="%">
			</custom-input>

			<custom-input ngDefaultControl
						  [id]="'montant_' + i"
						  [name]="'montant_' + i"
						  [(ngModel)]="indemnite.montant"
						  customType="montant"
						  [lCol]="1"
						  [rCol]="3"
						  [nbDecimales]="2"
						  [montantDevise]="deviseSelectionnee"
						  [disabledDevise]="true"
						  (onChange)="onMontantIndemniteChange(indemnite)"
						  [required]="!hasIndemnite">
			</custom-input>
		</div>

		<!-- Pourcentage total -->
		<div class="row" >
			<div class="col-3 text-end text-muted small">
				<em [translate]="'admin.frais.indemnites.fraisMissions.detail.datesApplication.total'"></em>
			</div>
			<div class="col-2 text-end text-muted small">
				<em *ngIf="hasPourcentage">{{ pourcentageTotal | number:'1.2-2' }} %</em>
			</div>
			<div class="col-3 text-muted small">
				<em *ngIf="hasIndemnite">{{ montantTotalIndemnites | number:'1.2-2' }} {{ deviseSelectionnee }}</em>
			</div>
		</div>
	</form>
</div>

<div mat-dialog-actions align="end">
	<button mat-stroked-button color="warn" *ngIf="!isCreation" (click)="onDelete()">
		<span [translate]="'global.actions.supprimer'"></span>
	</button>
	<button mat-flat-button color="primary" (click)="onSave()" [disabled]="form.invalid || !hasIndemnite">
		<span [translate]="'global.actions.enregistrer'"></span>
	</button>
</div>